import { gql } from '@apollo/client';

export const TENANT_CONFIG_QUERY = gql`
  query tenantConfig {
    tenantConfig {
      id
      tenantName
      doseUnit
      ariaDoseUnit
      mosaiqDoseUnit
      fractionUnit
      documentApprovalStatuses
      cpotEnabled
      requestTemplateChangeActive
      contrastRequiredChildFields
      showOarTemplateWhenNoOars
      targetValueDoseSuffixEnabled
      voidCareplanExpiryPeriod
      enableMrlSafetyScreening
      showTreatmentReview
      showManageProtocols
      showIsocenterField
      appointmentDescriptionSource
      appConfigOverrides
    }
  }
`;
